import { Outlet } from "react-router-dom";

import routesArr from "routes";

import Nav from "./Nav";
import Header from "./Header";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import DayRange from "components/Util/DayRange";

export default function AdminLayout() {
  const routes = routesArr[0].children[1].children;
  const [farmName, setFarmName] = useState(sessionStorage.getItem("farm_name"));
  const { logout } = useAuth0();

  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 4);
  const endDate = new Date();
  endDate.setHours(0, 0, 0);
  const [dayRange, setDayRange] = useState({ startDate, endDate });

  return (
    <>
      <Header routes={routes} onUpdate={setFarmName} />
      <div className="min-h-screen lg:flex pt-16 relative">
        {farmName === null ? null : <Nav routes={routes} />}
        <div className="grow relative">
          {farmName === null ? (
            <main className="mb-10 lg:mb-20">
              <div className="text-center">
                <div className="inline-block mx-auto mt-16 text-center bg-white px-12 py-10 border border-gray-100 font-[Avenir]">
                  <h1 className="text-lg tracking-tight text-gray-800">Please get in touch with us, to get you started!</h1>
                  <div className="mt-6 flex justify-center gap-5">
                    <div className="rounded-md shadow">
                      <a
                        className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-sm text-white bg-blue-500 hover:bg-blue-600"
                        href="https://www.greentech.technology/#contact-anchor"
                      >
                        Contact us
                      </a>
                    </div>
                    <div className="rounded-md">
                      <button
                        onClick={() => {
                          sessionStorage.removeItem("farm_name");
                          logout();
                        }}
                        className="w-full flex items-center justify-center px-4 py-2 border border-gray-200 text-base font-medium rounded-sm text-blue-500 bg-white hover:bg-gray-100"
                      >
                        Logout
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          ) : (
            <main className="mb-10 lg:mb-20 p-1">
              <div className="flex justify-end px-5 lg:px-12 max-w-sm md:max-w-7xl mt-5 mx-auto">
                <DayRange dayRange={dayRange} onUpdate={setDayRange} />
              </div>
              <Outlet context={[farmName, dayRange]} />
            </main>
          )}
          <footer className="p-4 bg-gray-200 text-center text-xs lg:absolute bottom-0 w-full">
            <div className="copyright">
              © {new Date().getFullYear()} made by{" "}
              <a href="https://hamari.agency" target="_blank" rel="noreferrer" className="text-blue-500">
                Hamari
              </a>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
}
